import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCreateCart } from '../../../../../../features/-cart_bak/create/createCart';
import * as v from 'valibot';
import { useForm } from '@tanstack/react-form';
import {
  Button,
  FormField,
  getErrors,
  Input,
  LicensePlate,
  PageHeader,
} from '@maia/ui';
import { formatLicensePlate, getSideCodeFromLicensePlate } from '@maia/utils';

export const Route = createFileRoute(
  '/_authenticated/cart/new/$customer/_layout/(object-code)/_layout/ob',
)({
  component: RouteComponent,
  validateSearch: v.object({
    guid: v.string(),
  }),
});

function RouteComponent() {
  const { guid: productGuid } = Route.useSearch();
  const { customer } = Route.useParams();
  const navigate = useNavigate();

  const { mutate, isPending } = useCreateCart(
    customer,
    {
      type: 'b2c',
      salesChannel: 'nkc',
    },
    ({ cart_guid }) =>
      navigate({
        to: '/cart/$guid/product/$product',
        params: {
          guid: cart_guid,
          product: productGuid,
        },
      }),
  );

  const form = useForm<{
    objectReference: string;
  }>({
    defaultValues: {
      objectReference: '',
    },
    onSubmit: ({ value }) =>
      mutate({
        selectedProducts: [
          {
            guid: productGuid,
            objectReference: value.objectReference,
          },
        ],
      }),
  });

  return (
    <>
      <PageHeader
        title="Primaire verzekeringsgegevens"
        backLink={{
          to: '/insurances',
        }}
        className="area-page-header"
      />
      <div className="area-page-content">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            form.handleSubmit();
          }}
          className="col-span-full"
        >
          <form.Field
            name="objectReference"
            validators={{
              onChange: v.pipe(
                v.string('Kenteken is verplicht'),
                v.trim(),
                v.minLength(1, 'Kenteken is verplicht'),
              ),
            }}
          >
            {(field) => (
              <FormField
                label="kenteken"
                error={getErrors(field)}
                inputSlot={
                  <div className="flex flex-row gap-12">
                    <LicensePlate
                      id={field.name}
                      name={field.name}
                      value={field.state.value}
                      className="w-fit"
                      disabled={isPending}
                      onBlur={(event) => {
                        const input = event.target.value
                          .toUpperCase()
                          .replace(/[^a-zA-Z0-9]/g, '');

                        const newValue = formatLicensePlate(
                          input,
                          getSideCodeFromLicensePlate(input),
                        );
                        field.handleBlur();
                        form.setFieldValue('objectReference', newValue);
                      }}
                      onChange={(event) =>
                        field.handleChange(event.target.value)
                      }
                    />
                    <Button
                      type="submit"
                      intent="primary"
                      size="large"
                      isDisabled={isPending}
                      isLoading={isPending}
                    >
                      Selecteer
                    </Button>
                  </div>
                }
              />
            )}
          </form.Field>
        </form>
      </div>
    </>
  )
}
